import { FiltersConfig } from './types';

export const getAllowedKeys = (config: FiltersConfig) =>
	Object.entries(config)
		.filter(([, enabled]) => enabled)
		.map(([key]) => key) as Array<keyof FiltersConfig>;

export const pickAllowed = (values: Record<string, unknown>, allowed: string[]) => {
	const out: Record<string, unknown> = {};
	for (const k of allowed) {
		if (k in values) out[k] = values[k];
	}
	return out;
};
